import api from "./api";

export const paymentApi = {
  list: (params = "") => api.get(`/payments${params}`),
  dashboard: () => api.get("/payments/dashboard"),
  getById: (id) => api.get(`/payments/${id}`),
  create: (data) => api.post("/payments", data),
  update: (id, data) => api.put(`/payments/${id}`, data),
  remove: (id) => api.delete(`/payments/${id}`),
};
